<template>
  <a-modal
    title="筛选条件另存为："
    :width="550"
    :visible="visible"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="按钮名称">
        <a-input v-decorator="['schemeName', { rules: [{ required: true, message: '请输入按钮名称' }] }]" />
      </a-form-item>
      <a-form-item label="按钮说明">
        <a-input v-decorator="['schemeExplain']" />
      </a-form-item>
      <a-form-item label="默认方案">
        <a-switch v-decorator="['defaultFlag']" :checked="form.getFieldsValue().defaultFlag" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { apiScpScreeningSchemeSaveScheme } from '@/api/scp/factoryCallMaterial/rawMaterialPlan'
// 表单字段
export default {
  props: {},
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      labelCol: {
        xs: { span: 12 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      // 表单校验
      form: this.$form.createForm(this),
      searchParam: null
    }
  },
  created () {},
  methods: {
    show (data) {
      this.searchParam = data
      this.visible = true
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
      this.confirmLoading = false
    },
    // 保存
    confirm () {
      this.confirmLoading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = this.form.getFieldsValue()
          params.bangingMenu = this.$route.meta.menuId
          params.sort = ""
          params.schemeDetailJson = JSON.stringify(this.searchParam)
          params.defaultFlag = params.defaultFlag ? "Y" : "N"
          apiScpScreeningSchemeSaveScheme(params).then(response => {
            if (response.code === 200) {
              this.$message.success('保存成功')
              // 调用外部刷新列表方法
              this.$emit('handle-success')
              // 刷新表单
              this.reset()
              // 关闭本组件
              this.visible = false
              this.confirmLoading = false
            } else {
              this.$message.error(response.msg)
              this.confirmLoading = false
            }
          })
        } else {
          this.confirmLoading = false
        }
      });
    },
    // 表单重置
    reset () {
      this.form.resetFields()
    }
  }
}
</script>

<style scoped lang="less">
input {
  width: 200px;
}
</style>
